import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirm-delete-content" }
const _hoisted_2 = { class: "confirm-delete-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.open,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
    persistent: "",
    width: "auto"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "bg-error" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-alert-circle-outline", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.message), 1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_btn, {
              variant: "outlined",
              color: "black",
              style: { padding: '14px 24px', display: 'flex', justifyContent: 'center', alignItems: 'center' },
              onClick: _ctx.closeModal
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Annuler ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_btn, {
              color: "error",
              variant: "flat",
              style: { padding: '14px 24px', display: 'flex', justifyContent: 'center', alignItems: 'center' },
              onClick: _ctx.confirmModal
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Supprimer ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}